<template>
  <TariffBox v-if="!loading"
    :showTariffSelect="true"
    :quickSelectionBrand="quickSelectionBrand"
    :showPriceStarts="noProviderSelected"
    :normalPrice = "promoBenefits.price"
    :promoPrice = "promoBenefits.promoPrice"
    :additionalPriceStairways = "promoBenefits.additionalPriceStairways"
    :startingBonus = "promoBenefits.startingBonus"
    :targetTariff = "targetTariff"
    :targetPromotions = "targetPromotions"
    cta-link="/bestellung"
  >
    <template v-for="slot in possibleChildSlotsFor('TariffBox')" v-slot:[`${slot.child}`]>
      <slot :name="`${slot.parent}`"></slot>
    </template>
  </TariffBox>
  <div class="tariff_box_skeleton card" v-else></div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'
import TariffBox from '@/components/checkout/tariff/generic/TariffBox.vue'

export default {
  name: 'TariffBoxWrapper',
  data () {
    return {
      loading: true
    }
  },
  components: {
    TariffBox
  },
  mixins: [
    trackingHandler
  ],
  created () {
    if (this.selectedTariff && this.selectedTariff.tariffId === '162') {
      this.SET_SELECTED_TARIFF(null)
    }
    this.loadDefaultTariff().then(async () => {
      await this.loadPresalePromotions()
      if (window.location.pathname === '/' || window.location.pathname === '') {
        let propositions = ''
        if (typeof window.trackingNS?.track?.getPropositions === 'function') {
          propositions = window.trackingNS.track.getPropositions(this.mnpData, undefined, this.selectedStarterKit, this.defaultTariff)
        }
        const data = {
          page_levels: [
            'homepage'
          ],
          login_status: 'not logged in', // check/set in tracking
          page_type: 'product detail',
          platform_type: 'browser view',
          propositions: propositions
        }
        this.trackData('pageview', data)
      }
    })
    this.updateCheckoutLandingStep()
  },
  watch: {
    selectedTariffOptionIds: function (v) {
      this.updateOrderCart()
    },
    mnpActive: function (v) {
      this.updateOrderCart()
      this.updateCheckoutLandingStep()
    },
    mnpProvider: function (v) {
      this.updateOrderCart()
    }
  },
  computed: {
    ...mapGetters('checkout', ['showProcess']),
    ...mapGetters('checkout/tariff', ['selectedTariff', 'selectedStarterKit', 'defaultTariff']),
    // checkoutv2
    ...mapGetters('checkoutv2/ordering/_mnpData', {
      mnpActive: 'active',
      mnpProvider: 'provider'
    }),
    ...mapGetters('checkoutv2/ordering/_cart', ['targetTariff', 'targetPromotions', 'promoBenefits', 'selectedTariffOptionIds']),
    noProviderSelected: function () {
      let tariffId = this.selectedTariff ? this.selectedTariff.tariffId : null
      if (tariffId === '155' && this.mnpActive) {
        tariffId = null
      }
      return this.mnpActive && tariffId === null
    },
    mnpData: function () {
      return {
        active: this.mnpActive,
        provider: this.mnpProvider
      }
    }
  },
  methods: {
    ...mapActions('checkout/tariff', ['loadDefaultTariff', 'setSelectedTariff']),
    ...mapMutations('checkout/tariff', ['SET_SELECTED_TARIFF']),
    ...mapMutations('promotion', ['savePresaleInclusive', 'savePresaleBookable']),
    // checkoutv2 store
    ...mapMutations('checkoutv2/ordering', ['setStep']),
    ...mapActions('checkoutv2/ordering/_cart', ['setOrderCart']),
    ...mapMutations('checkoutv2/ordering/_mnpData', [
      'setActive',
      'setProvider'
    ]),
    loadPresalePromotions () {
      const prefetchData = window.$gqlpre
      this.savePresaleInclusive({
        prefetchData: prefetchData.inclusiveAvailablePresalesPromotions !== null ? prefetchData.inclusiveAvailablePresalesPromotions : [],
        force: true
      })
      this.savePresaleBookable({
        prefetchData: prefetchData.bookableAvailablePresalesPromotions !== null ? prefetchData.bookableAvailablePresalesPromotions : [],
        force: true
      })
      this.updateOrderCart()
      this.loading = false
    },
    updateOrderCart () {
      let tariffId = this.selectedTariff ? this.selectedTariff.tariffId : null
      if (this.noProviderSelected) {
        tariffId = null
      }
      const tariffoptionId = this.selectedTariffOptionIds.length > 0 ? this.selectedTariffOptionIds[0] : null
      this.setOrderCart({ tariffId: tariffId, tariffoptionId, mnp: this.mnpActive, provider: this.mnpProvider?.key || null })
    },
    updateCheckoutLandingStep () {
      if (this.mnpActive) {
        this.setStep('mnpData')
      } else {
        this.setStep('customerData')
      }
    }
  },
  props: {
    quickSelectionBrand: {
      type: String,
      default: ''
    }
  }
}
</script>
